import { Component, EventEmitter, Input, Output } from '@angular/core';
import { centsToDollars, dollarsToCents } from '@core/util/money';
import { LLCTransaction } from '@models/llc-mortgages';
import { ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { MatterDispatch } from '@state/matter';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { isNumber } from 'lodash';
import { ICON } from '@core/util/icon';

@Component({
	selector: 'app-llc-purchase-price-sync',
	templateUrl: './purchase-price.component.html',
	styleUrls: ['./purchase-price.component.scss'],
	standalone: false,
})
export class PurchasePriceComponent {
	public ICON = ICON;

	@ViewSelectSnapshot(SelectedMatter.purchasePrice) purchasePrice: number;

	@Output() next: EventEmitter<void> = new EventEmitter();
	@Input() transaction: LLCTransaction;

	constructor(private matterDispatch: MatterDispatch) {}

	sync() {
		const transactionPurchasePrice = this.transaction?.data?.mortgage
			?.purchasePrice
			? dollarsToCents(
					this.transaction?.data?.mortgage?.purchasePrice?.toString(),
				)
			: 0;

		if (
			!this.equal &&
			transactionPurchasePrice != null &&
			isNumber(transactionPurchasePrice)
		) {
			this.matterDispatch.SetSalePrice(
				this.transaction.matterId,
				transactionPurchasePrice,
			);
		}

		this.next.emit();
	}

	_next() {
		this.next.emit();
	}

	get equal() {
		return (
			Number(centsToDollars(this.purchasePrice)) ===
			Number(this.transaction?.data?.mortgage?.purchasePrice)
		);
	}

	get mortgagePurchasePrice() {
		return this.transaction?.data?.mortgage?.purchasePrice ?? 0;
	}
}
